import { isPreviewMode } from "@/lib/sanity";

const PreviewBanner = () => {
  if (!isPreviewMode()) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-amber-500 text-black text-center py-1.5 text-xs font-bold tracking-wide">
      PREVIEW MODE: You are viewing draft content.{" "}
      <a
        href={window.location.pathname}
        className="underline underline-offset-2"
        onClick={(e) => {
          e.preventDefault();
          window.location.href = window.location.pathname;
        }}
      >
        Exit preview
      </a>
    </div>
  );
};

export default PreviewBanner;
